import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthLoginPage } from '@features/auth/pages/AuthLoginPage';
import { AuthSignupPage } from '@features/auth/pages/AuthSignupPage';
import { ForgotPasswordPage } from '@features/auth/pages/ForgotPasswordPage';

/**
 * Routes for auth subdomain (auth.v2.meitre.com).
 * Only login and signup — no booking, no tenant.
 */
export function AuthRouter() {
  return (
    <Routes>
      <Route path="/login" element={<AuthLoginPage />} />
      <Route path="/signup" element={<AuthSignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      {/* Default → login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
